export default __webpack_public_path__ + "static/media/icon-Table-View.4af9172a.svg";